/** Public UPS tracking URL used on storefront order views. */
export function buildUpsTrackingHref(trackingId: string): string {
    const id = trackingId.trim();
    return `https://www.ups.com/track?tracknum=${encodeURIComponent(id)}`;
}
